// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"b2aaf301","130":"2e101435","174":"ec431d53","369":"35cae6c1","435":"ce51225b","636":"0cb0f7ec","652":"72b2d3a5","721":"8176365d","775":"6e26dff8","858":"050e592c","932":"cc1a6973","964":"6e03f816","965":"8f5c86ef","966":"713951eb"}[chunkId] + ".chunk.js";
};